/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/* eslint-disable import/prefer-default-export */
/* eslint-disable new-cap */
import moment from 'moment';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { numGradeToEUgradeEW, levelToCEFR } from '../../../../helpers/utils';
import img from '../../../../shared/img/logo/logo.png';
import footer from '../../../../shared/img/footer.png';
import skillServices from '../../../../redux/services/skillServices';

const generatePDF = async (courseInfos, contentTitles, specificSkills, student, t, languageVar) => {
  const bodyObjectives = [];
  courseInfos.objectives.forEach((objective) => {
    bodyObjectives.push([objective.name]);
  });

  let language = languageVar === 'en' ? 'EN' : 'FR';
  if (courseInfos.language.name === 'English') language = 'FR';
  else if (courseInfos.language.name === 'French') language = 'FR';
  else if (courseInfos.language.name === 'German') language = 'FR';
  else if (courseInfos.language.name === 'Chinese') language = 'FR';
  else if (courseInfos.language.name === 'Luxembourgish') language = 'FR';
  else if (courseInfos.language.name === 'Italian') language = 'FR';

  let grammarLanguage = 'EN';
  if (courseInfos.language.name === 'English') grammarLanguage = 'EN';
  else if (courseInfos.language.name === 'French') grammarLanguage = 'FR';
  else if (courseInfos.language.name === 'German') grammarLanguage = 'DE';
  else if (courseInfos.language.name === 'Chinese') grammarLanguage = 'CH';
  else if (courseInfos.language.name === 'Luxembourgish') grammarLanguage = 'LU';
  else if (courseInfos.language.name === 'Italian') grammarLanguage = 'IT';

  await skillServices.getSkills();

  const items = [
    { title: t('pdf.coursePlan.entity', 'Entité'), body: courseInfos.company.name },
    {
      title: t('pdf.coursePlan.trainingName', 'Intitulé de la formation'),
      body: courseInfos.name ? courseInfos.name : t('common.noNameRegistered', 'No name registered'),
    },
    {
      title: t('pdf.coursePlan.languageAndLevel', 'Langue et niveau'),
      body:
        (courseInfos.level || courseInfos.level === 0) && courseInfos.language
          ? `${courseInfos.language.name} - ${levelToCEFR(courseInfos.level)}`
          : t('common.noLevelChosen', 'No level chosen'),
    },
    {
      title: t('pdf.coursePlan.duration', 'Durée'),
      body: courseInfos.coursePlan.duration ? `${courseInfos.coursePlan.duration}h` : t('common.noDurationChosen', 'No duration chosen'),
    },
    {
      title: t('pdf.coursePlan.startDate', 'Date de début'),
      body: courseInfos.coursePlan.beginDate
        ? moment(courseInfos.coursePlan.beginDate).format('DD/MM/YYYY')
        : t('common.noBeginningDateChosen', 'No beginning date chosen'),
    },
    {
      title: t('pdf.coursePlan.endDate', 'Date de fin'),
      body: courseInfos.coursePlan.endDate
        ? moment(courseInfos.coursePlan.endDate).format('DD/MM/YYYY')
        : t('common.noEndingDateChosen', 'No ending date chosen'),
    },
    {
      title: t('pdf.coursePlan.teacher', 'Formateur'),
      body: Array.isArray(courseInfos.idTeachers) && courseInfos.idTeachers.length > 0
        ? courseInfos.idTeachers.map((tt) => `${tt.name} ${tt.firstname}`).join(', ')
        : 'n/a',
    },
  ];

  const bodySkills = [];

  if (contentTitles && contentTitles.length > 0) {
    contentTitles.forEach((contentTitle) => {
      contentTitle.content.forEach((skill, index) => {
        if (skill.categories?.includes('vocPro') && courseInfos.coursePlan?.vocPro) {
          skill.categoriesVoc = courseInfos.coursePlan.vocPro;
        }
        if (skill.categories?.includes('vocInterests') && courseInfos.coursePlan?.vocInterests) {
          skill.categoriesVoc = courseInfos.coursePlan.vocInterests;
        }
        if (skill.categories?.includes('vocWork') && courseInfos.coursePlan?.vocWork) {
          skill.categoriesVoc = courseInfos.coursePlan.vocWork;
        }
        let label = languageVar === 'en' ? skill.EN : skill.FR;
        if (skill.categoriesVoc) {
          let categories = label;
          skill.categoriesVoc.forEach((elem, indexSkill) => {
            if (indexSkill === skill.categoriesVoc.length - 1) categories += ` ${elem}.`;
            else categories += ` ${elem},`;
          });
          label = categories;
        }
        if (index === 0) {
          bodySkills.push([
            { content: languageVar === 'en' ? contentTitle.EN : contentTitle.FR, rowSpan: contentTitle.content.length },
            { content: label },
          ]);
        } else {
          bodySkills.push([{ content: label }]);
        }
      });
    });
  }

  if (specificSkills) {
    specificSkills.forEach((specificSkill, index) => {
      if (index === 0) {
        bodySkills.push([
          { content: t('pdf.coursePlan.specificSkills', 'Compétences spécifiques'), rowSpan: specificSkills.length },
          { content: languageVar === 'en' ? specificSkill.EN : specificSkill.FR },
        ]);
      } else {
        bodySkills.push([{ content: languageVar === 'en' ? specificSkill.EN : specificSkill.FR }]);
      }
    });
  }

  const footSkills = [];
  footSkills.push(
    [{ content: `\n${t('pdf.coursePlan.evaluationAndFollowUp', 'Evaluation et suivi')}: `, colSpan: 2, styles: { fontStyle: 'bold' } }],
    [{
      content: t(
        'pdf.coursePlan.evaluationText',
        'Contrôle régulier des connaissances et des acquis par des tests effectués par le formateur: {{middle}}{{end}}. \nBilan de fin de stage avec niveau et objectifs acquis.',
        {
          middle: courseInfos.coursePlan.middleTest ? t('pdf.coursePlan.middleTest', 'test intermédiaire, ') : '',
          end: courseInfos.coursePlan.endTest ? t('pdf.coursePlan.finalTest', 'test final') : '',
        },
      ),
      colSpan: 2,
    }],
    [{ content: `${t('pdf.coursePlan.prerequisites', 'Prérequis')}: `, colSpan: 2, styles: { fontStyle: 'bold' } }],
    [{
      content: t(
        'pdf.coursePlan.prerequisitesText',
        'Aucun prérequis n\'est nécessaire pour suivre cette formation. La formation s\'addresse à des personnes disposant d\'un niveau allant de débutant à C2. \nÉvaluation de la formation après 10h et en fin de stage.',
      ),
      colSpan: 2,
    }],
  );

  const bodyStudentScores = [];
  if (student) {
    bodyStudentScores.push([
      student?.name || 'n/a',
      student?.firstname || 'n/a',
      student?.test?.oralFluency || '',
      student?.test?.oralAccuracy || '',
      student?.test?.listeningComprehension || '',
      student?.test?.writing || '',
      student?.test?.readingComprehension || '',
      student?.test?.global || '',
      numGradeToEUgradeEW(parseFloat(student?.test?.global || 0)),
    ]);
  } else if (courseInfos.listIdUsers && courseInfos.listIdUsers.length > 0) {
    courseInfos.listIdUsers.forEach((studentItem) => {
      bodyStudentScores.push([
        studentItem?.name || 'n/a',
        studentItem?.firstname || 'n/a',
        studentItem?.test?.oralFluency || '',
        studentItem?.test?.oralAccuracy || '',
        studentItem?.test?.listeningComprehension || '',
        studentItem?.test?.writing || '',
        studentItem?.test?.readingComprehension || '',
        studentItem?.test?.global || '',
        numGradeToEUgradeEW(parseFloat(studentItem?.test?.global || 0)),
      ]);
    });
  }

  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'px',
    format: 'letter',
  });

  doc.addImage(img, 'PNG', 210, 20, 45, 30);
  doc
    .setFontSize(14)
    .text(
      t('pdf.coursePlan.title', 'Plan de développement des compétences'),
      doc.internal.pageSize.getWidth() / 2,
      70,
      { align: 'center' },
    );
  doc.setLineWidth(0.1).line(20, 90, 430, 90);

  autoTable(doc, {
    body: items,
    margin: { left: 20, top: 100 },
    styles: { fontSize: 9 },
    columnStyles: { 0: { fontStyle: 'bold' } },
  });

  autoTable(doc, {
    head: [[t('pdf.coursePlan.objectives', 'Objectifs de la formation: ')]],
    body: bodyObjectives,
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      fontSize: 9,
    },
    rowPageBreak: 'avoid',
    styles: { fontSize: 9 },
    margin: { left: 20, top: 20 },
  });

  autoTable(doc, {
    head: [
      [{ content: t('pdf.coursePlan.levels', 'Niveaux'), colSpan: 9 }],
      [
        { content: t('common.lastName', 'Nom') },
        { content: t('common.firstName', 'Prénom') },
        { content: t('pdf.coursePlan.speaking', 'Expression orale'), colSpan: 2 },
        { content: t('pdf.coursePlan.listening', 'Compréhension orale') },
        { content: t('pdf.coursePlan.writing', 'Expression écrite') },
        { content: t('pdf.coursePlan.reading', 'Compréhension écrite') },
        { content: t('pdf.coursePlan.globalLevel', 'Niveau global'), colSpan: 2 },
      ],
      [
        { content: '', colSpan: 2 },
        { content: t('pdf.coursePlan.fluency', 'Fluidité') },
        { content: t('pdf.coursePlan.accuracy', 'Précision') },
        { content: '' },
        { content: t('pdf.coursePlan.onlineTestNewParticipants', 'Test en ligne pour les nouveaux participants'), colSpan: 2 },
        { content: t('pdf.coursePlan.ew', 'EW') },
        { content: t('pdf.coursePlan.cefrStar', 'CEFR*') },
      ],
    ],
    body: bodyStudentScores,
    margin: { left: 20, top: 20 },
    styles: { fontSize: 9, valign: 'middle', halign: 'center' },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      fontSize: 9,
      lineWidth: 0.5,
    },
    bodyStyles: { lineWidth: 0.5 },
    showFoot: 'lastPage',
    rowPageBreak: 'avoid',
    theme: 'grid',
  });

  autoTable(doc, {
    head: [
      [{ content: t('pdf.coursePlan.levelsInterpretation', "Tableau d'interprétation des niveaux"), colSpan: 10 }],
      [
        '',
        t('pdf.coursePlan.beginner', 'Débutant'),
        t('pdf.coursePlan.elementary', 'Elémentaire'),
        t('pdf.coursePlan.preIntermediate', 'Pré-intermédiaire'),
        { content: t('pdf.coursePlan.intermediate', 'Intermédiaire'), colSpan: 2 },
        t('pdf.coursePlan.advanced', 'Avancé'),
        t('pdf.coursePlan.independent', 'Autonome'),
        t('pdf.coursePlan.mastery', 'Maîtrise'),
        t('pdf.coursePlan.bilingual', 'Bilingue'),
      ],
    ],
    body: [
      ['EW', '0-2', '3', '4', '5', '6', '7', '8', '9', '10'],
      [{ content: t('pdf.coursePlan.councilOfEuropeStar', "Conseil de l'Europe*"), rowSpan: 2 }, '', 'A1', 'A2', { content: 'B1', colSpan: 2 }, 'B2', 'C1', 'C2', ''],
      [
        t('pdf.coursePlan.beginner', 'Débutant'),
        { content: t('pdf.coursePlan.elementaryUser', 'Utilisateur élémentaire'), colSpan: 2 },
        { content: t('pdf.coursePlan.independentUser', 'Utilisateur indépendant'), colSpan: 3 },
        { content: t('pdf.coursePlan.proficientUser', 'Utilisateur expérimenté'), colSpan: 2 },
        '',
      ],
    ],
    foot: [[{ content: t('pdf.coursePlan.cecrFoot', '* Cadre européen commun de référence pour les langues (CECR)'), colSpan: 9 }]],
    margin: { left: 20, top: 20 },
    styles: { fontSize: 9, valign: 'middle', halign: 'center' },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      fontSize: 9,
      lineWidth: 0.5,
    },
    footStyles: {
      halign: 'left',
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      fontSize: 7,
      lineWidth: 0.5,
      fontStyle: 'normal',
    },
    rowPageBreak: 'avoid',
    showHead: 'firstPage',
    pageBreak: 'avoid',
    bodyStyles: { lineWidth: 0.5 },
    columnStyles: { 4: { cellWidth: 30 }, 5: { cellWidth: 30 } },
    theme: 'grid',
  });

  autoTable(doc, {
    head: [
      [{ content: t('pdf.coursePlan.trainingContent', 'Contenu de la formation'), colSpan: 2 }],
      [t('pdf.coursePlan.categories', 'Catégories'), t('pdf.coursePlan.skills', 'Compétences')],
    ],
    body: bodySkills,
    margin: { left: 20, top: 20 },
    styles: { fontSize: 9, valign: 'middle' },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      fontSize: 9,
      lineWidth: 0.5,
      halign: 'center',
    },
    columnStyles: { 0: { halign: 'center' } },
    bodyStyles: { lineWidth: 0.5 },
    rowPageBreak: 'avoid',
    showHead: 'firstPage',
    pageBreak: 'avoid',
    theme: 'grid',
  });

  autoTable(doc, {
    foot: footSkills,
    margin: { left: 20, top: 20 },
    styles: { fontSize: 9, valign: 'middle' },
    footStyles: {
      halign: 'left',
      fillColor: [255, 255, 255],
      textColor: [64, 64, 64],
      fontStyle: 'normal',
    },
    rowPageBreak: 'avoid',
    theme: 'grid',
  });

  autoTable(doc, {
    body: [[{ content: '', colSpan: 1 }]],
    styles: {
      fontSize: 7,
      minCellWidth: 300,
      minCellHeight: 110,
      lineWidth: 0,
    },
    bodyStyles: { fillColor: [255, 255, 255], lineWidth: 0 },
    theme: 'grid',
    margin: { left: 20, top: 30 },
    rowPageBreak: 'avoid',
    didDrawCell(data) {
      const textPos = data.cell;
      data.cell.styles.fillColor = [255, 255, 255];
      doc.addImage(footer, textPos.x + 100, textPos.y + 5, 240, 130);
    },
  });

  doc.save('course_plan.pdf');
};

export { generatePDF };
